import { Component, OnInit } from '@angular/core';
import { OrgaoJustica } from '../../orgao-justica/orgao-justica.model';
import { OrgaoJusticaService } from '../../orgao-justica/orgao-justica.service';
import { Jurisdicao } from '../jurisdicao.model';
import { Frm } from '../../components/frm/frm.interface';
import { MensagemService } from 'maestro-ng';

@Component({
  selector: 'app-jurisdicao-frm',
  templateUrl: './jurisdicao-frm.component.html',
  styleUrls: ['./jurisdicao-frm.component.css'],
})
export class JurisdicaoFrmComponent implements OnInit, Frm<Jurisdicao, number> {
  entidade: Jurisdicao;
  orgaoJusticaItens: OrgaoJustica[];

  constructor(private orgaoJusticaService: OrgaoJusticaService, private mensagemService: MensagemService) {}

  ngOnInit(): void {
    this.orgaoJusticaService
      .recuperarItens()
      .then((orgaoJustica) => {
        this.orgaoJusticaItens = orgaoJustica;
      })
      .catch((resposta) => {
        this.mensagemService.addErro('Erro', 'Erro ao encontrar orgãos justiça: ' + resposta.message);
      });
  }

  iniciarAlteracao(entidade: Jurisdicao): void {
    this.entidade = entidade;
  }

  iniciarAlteracaoPorId(): void {}

  iniciarInsercao(): void {}

  salvar(): void {}
}
